import { render, staticRenderFns } from "./FraccionesFormList.vue?vue&type=template&id=df14ac8c&"
import script from "./FraccionesFormList.vue?vue&type=script&lang=js&"
export * from "./FraccionesFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports